import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ResetPasswordService } from '../reset-password.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.css'],
})
export class VerifyOtpComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private serviceAuth: ResetPasswordService,
    private router: Router,
  ) {
    this.loginForm = this.fb.group({
      otp: ['', [Validators.required]],
    });
  }

  image_key = environment.client_env;
  //@ts-ignore
  imageUrl = environment[this.image_key]['sidebar_image'];
  loginForm: FormGroup;
  emailId: '';
  otp: String = '';
  errorMessageUserName = '';
  errorMessagePassword = '';
  errorMsg = 'Error';
  submited = false;
  failedAuth = false;
  ngOnInit() {}

  get f() {
    return this.loginForm.controls;
  }
  onSubmit(form: FormGroup) {
    this.submited = true;
    this.emailId = JSON.parse(localStorage.getItem('resetPasswordData'))[
      'email_address'
    ];
    this.serviceAuth
      .VerifyOTP(this.emailId, form.value['otp'])
      .then((result) => {
        if (result['success'] === '1') {
          // this.router.navigateByUrl('');
          let token = result['data']['token'];
          localStorage.setItem('token', JSON.stringify(token));
          this.router.navigateByUrl('/reset-old-password');
        } else {
          this.errorMsg = result['message'];
          this.failedAuth = true;
          if (this.errorMsg == 'Exceeded maximum attempts') {
            this.errorMsg =
              'You have exceeded the maximum number of attempts to enter correct verification code';
            setTimeout(() => {
              this.router.navigateByUrl('/login');
            }, 3000);
          }
        }
      })
      .catch((error) => {});
  }
  resetForm() {
    this.submited = false;
    this.failedAuth = false;
  }
}
